import {cx as addStyles, css} from '@emotion/css';
import {CustomerItemStatusDescription, Modal, theme} from '@remoov/remoov-components';
import React, {HTMLAttributes} from 'react';
import {InfoText} from './Common';

export type StatusMeaningModalProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => unknown;
};

export const StatusMeaningModal = ({isOpen, setIsOpen}: StatusMeaningModalProps) => (
  <Modal title='What each status mean' isOpen={isOpen} setModal={setIsOpen}>
    <Content>
      {Object.entries(CustomerItemStatusDescription).map(([title, description], i) => (
        <LineInfoContainer key={i}>
          <Title>{title}</Title>
          <Value>{description}</Value>
        </LineInfoContainer>
      ))}
    </Content>
  </Modal>
);
const Content = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: theme.spacings.small,
      [theme.mediaMaxWidth.small]: {gap: '20px'},
    })}
    {...args}
  />
);
const LineInfoContainer = ({className, ...rest}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={addStyles(
      css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacings.large,
        [theme.mediaMaxWidth.small]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: `calc(${theme.spacings.xxsmall}/2)`,
        },
      }),
      className,
    )}
    {...rest}
  />
);
const Title = (args: HTMLAttributes<HTMLSpanElement>) => (
  <InfoText
    className={css({color: theme.colors.darkBlue, fontWeight: theme.font.medium, width: '80px'})}
    {...args}
  />
);
const Value = (args: HTMLAttributes<HTMLSpanElement>) => (
  <InfoText
    className={css({whiteSpace: 'nowrap', [theme.mediaMaxWidth.small]: {whiteSpace: 'normal'}})}
    {...args}
  />
);
